import { Card, CardBody, Col } from "reactstrap";
import { LI, UL } from "../../../AbstractElements";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BorderLeftTitle } from "../../../Constants/Constants";
import { BorderLeftSubTitle } from "../../../Data/BonusUi/CreativeCard";

const BorderLeft = () => {
  return (
    <Col md="6" xs="12">
      <Card>
        <CommonCardHeader title={BorderLeftTitle} span={BorderLeftSubTitle} headClass="border-l-primary pb-0" />
        <CardBody>
          <UL className="d-flex flex-column gap-1 simple-list">
            <LI>{"You can design your creative card by taking only the "}<strong>{"border-l-primary "}</strong>{" class. If you want to use other colors like this: "}<strong>{"border-l-*"}</strong></LI>
            <LI><strong>{"Visit Us: "}</strong> {"2600 Hollywood Blvd,Florida, United States-33020"}</LI>
            <LI><strong>{"Mail Us: "}</strong>{"contact@us@gmail.com"}</LI>
            <LI><strong>{"Contact Number: "}</strong>{"(954) 357-7760"}</LI>
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};
export default BorderLeft;
